// extracted by mini-css-extract-plugin
module.exports = {"container":"modal_confirmation_footer-module__container---d44K"};